import React from 'react'
import { groupBy, sortBy } from 'lodash-es'
import useEventSessionsQuery, {
  isPreviousNotOnDemand,
} from '../../../../../hooks/useEventSessionsQuery'
import type { WebinarEvent } from '../../../../../hooks/useEventSessionsQuery'

import SessionCard from './SessionCard/SessionCard'

import './SessionsDrawer.scss'

const groups = ['live', 'upcoming', 'previous']

interface SessionsDrawerProps {
  seriesId: number
  seriesToken: string
  sessionId: string
}

const getShouldShowHeader = (groupName: string) => {
  return groupName !== 'live'
}

const getButtonText = (session: WebinarEvent) => {
  switch (session.liveStatus) {
    case 'live':
      return 'Join now'
    case 'previous':
      return 'Watch'
    case 'upcoming':
    default:
      return 'Switch room'
  }
}

// eslint-disable-next-line react/display-name
export default ({ seriesId, seriesToken, sessionId }: SessionsDrawerProps) => {
  const { data: eventSessions } = useEventSessionsQuery({
    id: seriesId,
    token: seriesToken,
    refetchInterval: 10_000,
    excludeSessionId: sessionId,
    includePrivate: true,
    includeSpeakers: true,
  })

  const filteredSessions = eventSessions?.filter(
    (session) => !isPreviousNotOnDemand(session)
  )
  const groupedSessions = groupBy(filteredSessions, 'liveStatus')

  return (
    <div className="sessions-drawer">
      {groups.map((groupName) => {
        const sessions = groupedSessions[groupName]
        if (!sessions) return null
        return (
          <div className="group" key={groupName}>
            {getShouldShowHeader(groupName) && (
              <div className="group-header">{groupName}</div>
            )}
            {sortBy(sessions, 'startDate').map((session) => (
              <SessionCard
                key={session.name}
                title={session.name}
                thumbnailUrl={session.thumbnail}
                linkUrl={session.linkSwitch}
                startDate={session.startDate}
                endDate={session.endDate}
                names={session.speakers.map((speaker) => speaker.name)}
                isLive={session.liveStatus === 'live'}
                buttonText={getButtonText(session)}
              />
            ))}
          </div>
        )
      })}
    </div>
  )
}
